import { Injectable } from '@angular/core';
import { FinanceSetting, GeneralSetting, OperationSettings, RegionalSettings, SchedulingSettings, SecurityRole, TenantInfoRequest, TenantSubscription, TenantUser, TimeBillingSettings, UserDeviceInfo, UserLoginRequest } from '@jms/model';
import { Action, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ApplicationActionName, ApplicationSettings, ApplicationState, SocialUser } from './application.state';



@Injectable({ providedIn: 'root' })
export class ApplicationActions {
    public state$: Observable<ApplicationState>;
    public settings$: Observable<ApplicationSettings>;
    public navExpanded$: Observable<boolean>;
    public route$: Observable<any>;
    public token$: Observable<string>;
    public user$: Observable<TenantUser>;
    public role$: Observable<SecurityRole>;
    public tenantInfo$: Observable<TenantInfoRequest>;
    public tenantPackage$: Observable<TenantSubscription>;
    public tenantRegion$: Observable<RegionalSettings>;
    public tenantScheduleSetting$: Observable<SchedulingSettings>;
    public operationsSetting$: Observable<OperationSettings>;
    public timeBillingSetting$: Observable<TimeBillingSettings>;
    public tenantFinanceSetting$: Observable<FinanceSetting>;
    public generalSetting$: Observable<GeneralSetting>;
    // public tenantXeroConsumerKeys$: Observable<{ consumerKey: string, consumerSecret: string }>;


    constructor(
        public store: Store<any>
    ) {

        this.state$ = store.select(x => x.application);
        this.user$ = store.select(x => x.application.user);
        this.role$ = store.select(x => x.application.role);
        this.token$ = store.select(x => x.application.token);
        this.navExpanded$ = store.select(x => x.application.navExpanded);
        this.route$ = store.select(x => x.application.route);
        this.settings$ = store.select(x => x.application.settings);
        this.tenantInfo$ = store.select(x => x.application.info);
        this.tenantPackage$ = store.select(x => x.application.info?.package?.package);
        this.tenantRegion$ = store.select(state => state.application.info.generalSettings.region);
        this.tenantScheduleSetting$ = store.select(state => state.application.info.generalSettings.schedule);
        this.operationsSetting$ = store.select(state => state.application.info.generalSettings.operations);
        this.timeBillingSetting$ = store.select(state => state.application.info.generalSettings.timeBilling);
        this.tenantFinanceSetting$ = store.select(state => state.application.info.generalSettings.finance);
        this.generalSetting$ = store.select(state => state.application.info.generalSettings);
        // this.tenantXeroConsumerKeys$ = store.select(state => state.application.info.xeroConsumerKeys);

    }

    dispatch(action: Action) {
        this.store.dispatch(action);
    }

    toggleNav(dispatch = true) {
        const action = {
            type: ApplicationActionName.ToggleNav
        };

        if (dispatch) this.dispatch(action);

        return action;
    }

    logout(force: boolean = false, dispatch = true) {
        const action = {
            type: ApplicationActionName.Logout,
            payload: {
                force: force
            }
        };

        if (dispatch) this.dispatch(action);

        return action;
    }

    routerNavigatating(data, dispatch = true): Action {
        const action = {
            type: ApplicationActionName.RouterNavigating,
            payload: data
        };

        if (dispatch) this.store.dispatch(action);

        return action;
    }

    routerNavigated(data, dispatch = true): Action {
        const action = {
            type: ApplicationActionName.RouterNavigated,
            payload: data
        };

        if (dispatch) this.store.dispatch(action);

        return action;
    }

    loginAuthorise(token: string, domain: string, returnUrl: string, dispatch = true) {
        const payload = { token, domain, returnUrl };
        const action = {
            type: ApplicationActionName.LoginAuthorise,
            payload: payload
        };

        if (dispatch) this.dispatch(action);

        return action;
    }

    loginAuthorised(token: string, roleToken: string, returnUrl: string, dispatch = false) {
        const action = {
            type: ApplicationActionName.LoginAuthorised,
            payload: { token, roleToken, returnUrl }
        };

        if (dispatch) this.dispatch(action);

        return action;
    }

    loginError(error: any, dispatch = false) {
        const action = {
            type: ApplicationActionName.LoginError,
            payload: error
        };

        if (dispatch) this.dispatch(action);

        return action;
    }

    mapUser(user: UserLoginRequest, socialUser: SocialUser, dispatch = true) {
        const action = {
            type: ApplicationActionName.MapSocialUser,
            payload: {
                user: user,
                socialUser: socialUser,
                domain: user.domain
            }
        };

        if (dispatch) this.dispatch(action);

        return action;
    }

    requiredMapUser(data: any, dispatch = false) {
        const action = {
            type: ApplicationActionName.RequireMapUser,
            payload: data
        };

        if (dispatch) this.dispatch(action);

        return action;
    }

    getTenantInfo(callbackUrl: string, dispatch = true) {
        const action = {
            type: ApplicationActionName.GetTenantInfo,
            payload: callbackUrl
        };

        if (dispatch) {
            this.dispatch(action);
        }

        return action;
    }

    setDeviceInfo(device: UserDeviceInfo, dispatch = true) {
        const action = {
            type: ApplicationActionName.SetDeviceInfo,
            payload: device
        };

        if (dispatch) {
            this.dispatch(action);
        }

        return action;
    }

    public actionSuccess(successAction: string, payload: any, dispatch = false) {
        const action = {
            type: ApplicationActionName.ActionSuccess,
            payload: {
                type: successAction,
                payload: payload
            }
        };

        if (dispatch) this.store.dispatch(action);

        return action;
    }
}

export class SetGeneralSetting implements Action {
    readonly type = ApplicationActionName.SetGeneralSetting;

    public constructor(public data: GeneralSetting) { }
}
